"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.run_enemyShip = void 0;
var voyageMessageEnemyShipCommand_1 = require("@voyage/multi/voyageMessageEnemyShipCommand");
var voyageMessageEnemyShipCommand_sidecar_1 = require("@voyage/multi/voyageMessageEnemyShipCommand-sidecar");
function run_enemyShip() {
    voyageMessageEnemyShipCommand_sidecar_1.voyageMessageEnemyShipCommand.sendMessageAndImmediatelyExecute({
        command: voyageMessageEnemyShipCommand_1.EVoyageEnemyShipCommand.Create,
        type: voyageMessageEnemyShipCommand_1.EVoyageEnemyShipType.Hammerhead,
    });
}
exports.run_enemyShip = run_enemyShip;
